import { Component, OnInit, Input, EventEmitter, Output, ViewChild, ElementRef } from '@angular/core';
import { FirebaseNameOrConfigToken } from '@angular/fire';

@Component({
  selector: 'oc-tag',
  templateUrl: './tag.component.html',
  styleUrls: ['./tag.component.scss']
})
export class TagComponent implements OnInit {
  @Input() name;
  @Input() status = '';
  @Input() clickable = true;
  @ViewChild("tagInner",{static: true}) tagInner: ElementRef;
  approach = false;
  color = 'type-dark';

  tags = {
    'technology': {
      label: 'Science & Technology',
      type: 'standard'
    },
    'environmental-impacts': {
      label: 'Environmental Impacts',
      type: 'standard'
    },
    'governance': {
      label: 'Governance',
      type: 'standard'
    },
    'markets-finance': {
      label: 'Markets & Finance',
      type: 'standard'
    },
    'funding': {
      label: 'Funding',
      type: 'standard'
    },
    'cdr-community': {
      label: 'Our Community',
      type: 'standard'
    },
    'social-licensing': {
      label: 'Public Support',
      type: 'standard'
    },
    'microalgae': {
      label: 'Microalgae Cultivation',
      type: 'approach'
    },
    'fertilization': {
      label: 'Ocean Fertilization',
      type: 'legacy'
    },
    'upwelling': {
      label: 'Artificial Upwelling',
      type: 'legacy'
    },
    'blue-carbon': {
      label: 'Marine Habitat Restoration',
      type: 'approach'
    },
    'macroalgal': {
      label: 'Macroalgal Cultivation',
      type: 'approach'
    },
    'other-bio': {
      label: 'Other Biological',
      type: 'legacy'
    },
    'alkalinity': {
      label: 'Ocean Alkalinity Enhancement ',
      type: 'approach'
    },
    'downwelling': {
      label: 'Artificial Downwelling',
      type: 'legacy'
    },
    'co2-removal': {
      label: 'Electrochemical Ocean Capture',
      type: 'approach'
    },
    'storage': {
      label: 'Deep Sea Storage',
      type: 'approach'
    },
    'other-abio': {
      label: 'Other Abiotic',
      type: 'legacy'
    },
    'other': {
      label: 'Other',
      type: 'approach'
    },

  }

  constructor() { }

  ngOnInit() {
    if (this.tags[this.name].type === 'approach') {
      this.color = 'approach-dark';
      this.approach = true;
    }
    if (this.tags[this.name].type === 'legacy') {
      this.tagInner.nativeElement.parentNode.classList.add('legacy-oc-tag')
    }
    
  }

  // ngOnChanges(changes: SimpleChanges) {
  //   if(changes.hasOwnProperty('color') && !changes.hasOwnProperty('name')) {
  //     this.setColor();
  //   }
  // }

}
